import ArrowUp from "./SVG/arrowUp.svg?react";

const ArrowDownIcon = () => {
  return <ArrowUp style={{ transform: "rotate(180deg)" }} />;
};

export default ArrowDownIcon;
